import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import RainBand from "@/components/RainBand";
import Works from "@/components/Works";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import StickyBar from "@/components/StickyBar";
import AdminPage from "@/pages/Admin";
import { ErrorBoundary } from "@/components/shared";

function LandingPage() {
    return (
        <div className="bg-bitume text-cloud min-h-screen">
            <Nav />
            <main>
                <Hero />
                <Marquee />
                <Services />
                <RainBand />
                <Works />
                <About />
                <Contact />
            </main>
            <Footer />
            <StickyBar />
        </div>
    );
}

export default function App() {
    const isAdmin = window.location.pathname === "/admin";
    useEffect(() => {
        if (isAdmin) return;
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (reduce) return;
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        let rafId = requestAnimationFrame(function loop(t) {
            lenis.raf(t);
            rafId = requestAnimationFrame(loop);
        });
        const onClick = (e) => {
            const a = e.target.closest?.('a[href^="#"]');
            if (!a) return;
            const href = a.getAttribute("href");
            if (href && href.length > 1) {
                const el = document.querySelector(href);
                if (el) {
                    e.preventDefault();
                    lenis.scrollTo(el, { offset: -70 });
                }
            }
        };
        document.addEventListener("click", onClick);
        return () => {
            cancelAnimationFrame(rafId);
            document.removeEventListener("click", onClick);
            lenis.destroy();
        };
    }, [isAdmin]);

    if (window.location.pathname === "/admin") {
        return (
            <ErrorBoundary>
                <AdminPage />
                <Toaster position="top-center" richColors theme="dark" />
            </ErrorBoundary>
        );
    }

    return (
        <ErrorBoundary>
            <LandingPage />
            <Toaster position="top-center" richColors theme="dark" />
        </ErrorBoundary>
    );
}
